import React from 'react';
import ServicePageHero from '../ServicePageHero/ServicePageHero';

const ServiceLandscapeHero = () => (
  <ServicePageHero
    breadcrumbLabel="Landscape Design"
    titlePrimary="Landscape design"
    titleAccent=" that starts with you."
    subtext="From the first conversation to the finished yard, we design, source, and build custom landscapes tailored to how you actually want to live outside."
  />
);

export default ServiceLandscapeHero;
